// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "气动与液压系统",
      "tec": "谷艳丰",
      "week": "1,3,5,7周",
      "add": "教学楼D座417文法"
    },
    [
      {
        "sub": "气动与液压系统",
        "tec": "谷艳丰",
        "week": "1-8双周",
        "add": "教学楼D座517机械AISEC"
      },
      {
        "sub": "机械零件设计",
        "tec": "罗旋",
        "week": "1-16单周",
        "add": "教学楼D座417文法"
      }
    ],
    {
      "sub": "工程有限元与数值计算",
      "tec": "刘劲涛",
      "week": "1-16周",
      "add": "教学楼A座416机械机房"
    },
    0,
    {
      "sub": "计算机建模与辅助工程",
      "tec": "张凯",
      "week": "3-14周",
      "add": "教学楼A座416机械机房"
    }
  ],
  "2": [
    0,
    {
      "sub": "机械工程控制与电路设计",
      "tec": "姜壹夫",
      "week": "1-8周",
      "add": "教学楼A座318机械"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "黄颖娜",
        "week": "1-5,7-9周",
        "add": "教学楼C座213教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "黄颖娜",
        "week": "10-13周",
        "add": "教学楼C座213教务"
      }
    ],
    {
      "sub": "能源电力工程与绿色低碳技术",
      "tec": "张翼马翔宇",
      "week": "1-8周",
      "add": "教学楼C座110教务"
    },
    0
  ],
  "3": [
    {
      "sub": "计算机数控技术",
      "tec": "范智广",
      "week": "1-12周",
      "add": "教学楼D座421机械AISEC"
    },
    {
      "sub": "机械零件设计",
      "tec": "罗旋",
      "week": "1-16周",
      "add": "教学楼D座417文法"
    },
    0,
    {
      "sub": "计算机建模与辅助工程",
      "tec": "张凯",
      "week": "3-14周",
      "add": "教学楼A座416机械机房"
    },
    0
  ],
  "4": [
    {
      "sub": "创新思维训练",
      "tec": "包妍",
      "week": "1-16周",
      "add": "教学楼D座421机械AISEC"
    },
    {
      "sub": "机械工程控制与电路设计",
      "tec": "姜壹夫",
      "week": "1-8周",
      "add": "教学楼A座318机械"
    },
    {
      "sub": "气动与液压系统",
      "tec": "谷艳丰",
      "week": "1-8周",
      "add": "教学楼D座417文法"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "计算机数控技术",
      "tec": "范智广",
      "week": "1-12周",
      "add": "教学楼D座421机械AISEC"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "黄颖娜",
        "week": "1-5,7-9周",
        "add": "教学楼A座422机械"
      },
      {
        "sub": "国家安全教育",
        "tec": "黄颖娜",
        "week": "10-13周",
        "add": "教学楼A座422机械"
      }
    ],
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
